import React from 'react';

import ConnectForm from '../../../common/forms/ConnectForm';

const ConnectScreen = () => {
  return (
    <>
      <div className="connect-screen" id="request-screen-container-id">
        <div className="tutorium-container">
          <div className="connect-screen-content">
            <div className="connect-screen-content-text-block">
              <p className="landing-caption-light">Do you want to try?</p>
              <p className="landing-text-light mt-20px">
                Fill the form and send the request. Our manager will contact you, answer all your questions. Then we
                will suggest a convenient time for the personal online meeting to discuss your requirements for training
              </p>
            </div>
            <div className="connect-screen-content-form-block">
              <ConnectForm />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConnectScreen;
